import React from 'react';
import { NIVEAUX_ETUDE, DOMAINES_FORMATION } from '../../constants/formOptions';
import { Field, TextInput, Select } from './fields';

const Education = ({ data, errors, onChange }) => {
  const bind = (name) => ({
    name,
    value: data[name] || '',
    error: errors[name],
    onChange: (e) => onChange({ [name]: e.target.value }),
  });

  return (
    <>
      <h2>Formation</h2>
      <p className="section-desc">Diplôme de statisticien ou de démographe, niveau licence minimum.</p>

      <div className="form-row two-cols">
        <Field label="Domaine" required error={errors.domaine_formation}>
          <Select {...bind('domaine_formation')} options={DOMAINES_FORMATION} />
        </Field>
        <Field label="Niveau" required error={errors.niveau_etude}>
          <Select {...bind('niveau_etude')} options={NIVEAUX_ETUDE} />
        </Field>
      </div>

      {data.domaine_formation === 'autre' && !errors.domaine_formation && (
        <div className="notice warn">
          Ce poste est réservé aux statisticiens et démographes.
        </div>
      )}

      <Field label="Intitulé du diplôme" required error={errors.diplome_obtenu}>
        <TextInput {...bind('diplome_obtenu')} placeholder="Ex. Ingénieur des travaux statistiques" />
      </Field>
    </>
  );
};

export default Education;
